/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Reducer file for authentication
 */

import {
  CMO_PO_STATS,
  CMO_FACILITIES_STATS,
  CMO_RMPM_STATS,
  CMO_RECENT_PO_UPDATES,
  CMO_RECENT_LINEITEMS_UPDATES
} from "../../actions/types";

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case CMO_PO_STATS:
      return {
        ...state,
        cmoPoStats: action.payload
      };
    case CMO_FACILITIES_STATS:
      return {
        ...state,
        cmoFacilities: action.payload
      };
    case CMO_RMPM_STATS:
      return {
        ...state,
        cmoRmPmStats: action.payload
      };
    case CMO_RECENT_PO_UPDATES:
      return {
        ...state,
        cmoPoRecentUpdates: action.payload
      };
    case CMO_RECENT_LINEITEMS_UPDATES:
      return {
        ...state,
        cmoPoRecentUpdates: action.payload
      };
    default:
      return state;
  }
}
